module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enabled) ? _c('button', {
    ref: "btn",
    class: ['dg-btn', 'dg-btn--cancel', {
      'dg-pull-right': _vm.options.reverse
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('click')
      }
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-68968d48!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/components/cancel-btn.vue
// module id = 67
// module chunks = 0